import {gql} from "@apollo/client";

export const GET_TASK_TYPES = gql`
  query GetTaskTypes {
    taskTypes {
      id
      name
      description
      isDeleted
      backgroundColor
      foregroundColor
      inUseBy {
        model
        count
      }
    }
  }
`;
export const CREATE_TASK_TYPE = gql`
  mutation CreateTaskType(
    $name: String!
    $description: String
    $backgroundColor: String
    $foregroundColor: String
  ) {
    createOneTaskType(
      data: {
        name: $name
        description: $description
        backgroundColor: $backgroundColor
        foregroundColor: $foregroundColor
      }
    ) {
      id
      name
      description
      backgroundColor
      foregroundColor
      isDeleted
    }
  }
`;
export const UPDATE_TASK_TYPE = gql`
  mutation UpdateTaskType(
    $id: Int!
    $name: String!
    $description: String
    $backgroundColor: String
    $foregroundColor: String
  ) {
    updateOneTaskType(
      where: {id: $id}
      data: {
        name: {set: $name}
        description: {set: $description}
        backgroundColor: {set: $backgroundColor}
        foregroundColor: {set: $foregroundColor}
      }
    ) {
      id
      name
      description
      backgroundColor
      foregroundColor
      isDeleted
    }
  }
`;
export const SOFT_DELETE_TASK_TYPE = gql`
  mutation SoftDeleteTaskType($id: Int!) {
    deleteOneTaskType(where: {id: $id}) {
      id
      name
      description
      backgroundColor
      foregroundColor
      isDeleted
    }
  }
`;
